import React, { Component } from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { Tabs, Card, Modal } from 'advenio-components'
import PropTypes from 'prop-types'
import { isNil, path } from 'ramda'
import shortid from 'shortid'
import { TABS_STUDENT_PROFILE } from '../../Constants'
import RecentActivity from '../../Components/ProfileViews/RecentActivity'
import Evaluation from '../../Components/ProfileViews/Evaluation/Evaluation'
import Profile from '../../Components/ProfileViews/Profile'
import ProfileMobile from '../../Components/ProfileViews/ProfileMobile'
import Contracts from '../../Components/ProfileViews/Contracts'
import CardsView from '../../Components/ProfileViews/CardsView'
import History from '../../Components/ProfileViews/History'
import Balance from '../../Components/ProfileViews/Balance'
import Notifications from '../../Components/ProfileViews/Notifications'
import Invoices from '../../Components/ProfileViews/Invoices'
import Receipts from '../../Components/ProfileViews/Receipts'
import StudentDocumentRepository from '../Documents/StudentDocumentRepository'
import { toPlainObject, userHasRole, isTeacher } from '../../utils/Utils'
import { gb } from '../../utils/growthbook'

const Container = styled.div`
  width: 100%;
`

const PageContainer = styled(Card)`
  margin-left: 16px;
  margin-right: 8px;
`
const PageContainerMobile = styled.div`
  @media (max-width:767px) {
    background-color: white;
    width: 100%;
    margin:0;
  }
`
const DesktopContainer = styled.div`
  display: none;
  @media (min-width:768px) {
    display: block;
  }
`

const MobileContainer = styled.div`
  display: none;
  @media (max-width:767px) {
    display: block;
  }
`

const Views = (props, virtual) => {
  const { isDisenrolled, studyPrograms, student: { study_program_id, id }, student, anyLoading, user } = props
  const [study_program] = studyPrograms.filter(program => program.id === study_program_id)
  const tabsDefault= [
    { title: TABS_STUDENT_PROFILE.recent_activity },
    { title: TABS_STUDENT_PROFILE.profile },
    { title: TABS_STUDENT_PROFILE.contract },
    { title: TABS_STUDENT_PROFILE.history },
    { title: TABS_STUDENT_PROFILE.cards },
    { title: TABS_STUDENT_PROFILE.evaluation },
    { title: TABS_STUDENT_PROFILE.documents },
    { title: TABS_STUDENT_PROFILE.balance},
    { title: TABS_STUDENT_PROFILE.notification },
    { title: TABS_STUDENT_PROFILE.receipts },
    { title: TABS_STUDENT_PROFILE.invoices },
    ]
  const feature = gb.getFeatureValue('modules', null)
  let tabs = tabsDefault
  if(!isNil(feature)){
    if(!isNil(feature.rules)){
      tabs = [...feature.rules[0].force.tabs.map(tab => toPlainObject({...tab}))]
    }else if(!isNil(feature.tabs)){
      tabs = [...feature.tabs.map(tab => toPlainObject({...tab}))]
    }
  }
  const views = {
    'Vista General': {
      tabs: [],
      views: [],
    },
    Classroom: {
      tabs: [],
      views: [],
    },
  }

  if (virtual) {
    views['Vista General'].tabs = [
      { title: TABS_STUDENT_PROFILE.recent_activity },
      { title: TABS_STUDENT_PROFILE.profile },
      { title: TABS_STUDENT_PROFILE.balance },
    ]
    views['Vista General'].views = [
      <RecentActivity
        key={shortid}
        history={props.student.latest_activities}
        onNewActivityClick={props.onNewActivityClick}
        onDeleteActivity={props.onDeleteActivity}
        categories={props.categories}
        onCheckIn={props.onCheckIn}
        student={props.student}
        isDisenrolled={isDisenrolled}
        onHealthCheck={props.onHealthCheck}
        anyLoading={anyLoading}
      />,
      <Profile
        key={shortid}
        profile={props.student}
        teacher={isTeacher(props.user.role)}
        isCheckin={props.student.checkin && props.student.checkin.is_virtual_center}
        isVirtualCenter={ props.student.checkin.is_virtual_center}
        studyPrograms={props.studyPrograms}
        user={props.user }
        isDisenrolled={isDisenrolled}
        anyLoading={anyLoading}
      />,
      <Balance
        key={shortid}
        anyLoading={anyLoading}
        student={props.student}
      />,
    ]
    if(student.country_id === 1 && !userHasRole(user, ['Teacher', 'Nurse','Receptionist'])){
      views['Vista General'].tabs.push({title: TABS_STUDENT_PROFILE.invoices })
      views['Vista General'].views.push(<Invoices studentId={id} />)
    }
    views.Classroom.tabs = [
      { title: TABS_STUDENT_PROFILE.recent_activity },
      { title: TABS_STUDENT_PROFILE.profile },
    ]
    views.Classroom.views = [
      <RecentActivity
        key={shortid}
        history={props.student.latest_activities}
        onNewActivityClick={props.onNewActivityClick}
        onDeleteActivity={props.onDeleteActivity}
        categories={props.categories}
        onCheckIn={props.onCheckIn}
        student={props.student}
        isDisenrolled={isDisenrolled}
        onHealthCheck={props.onHealthCheck}
        anyLoading={anyLoading}
      />,
      <Profile
        key={shortid}
        profile={props.student}
        studyPrograms={props.studyPrograms}
        isDisenrolled={isDisenrolled}
        teacher={isTeacher(props.user.role)
          || (props.student.checkin && props.student.checkin.is_virtual_center)}
        anyLoading={anyLoading}
        user={props.user}
        isCheckin={props.student.checkin && props.student.checkin.is_virtual_center}
        isVirtualCenter={ props.student.checkin.is_virtual_center}
      />,
    ]
  } else {
    views['Vista General'].tabs = tabs
    // Mapeo de tabs a componentes
    const tabToComponentMap = {
      [TABS_STUDENT_PROFILE.recent_activity]: () => (
        <RecentActivity
          history={props.student.latest_activities}
          onNewActivityClick={props.onNewActivityClick}
          onDeleteActivity={props.onDeleteActivity}
          categories={props.categories}
          onCheckIn={props.onCheckIn}
          student={props.student}
          isDisenrolled={isDisenrolled}
          onHealthCheck={props.onHealthCheck}
          anyLoading={anyLoading}
        />
      ),
      [TABS_STUDENT_PROFILE.profile]: () => (
        <Profile
          profile={props.student}
          studyPrograms={props.studyPrograms}
          onDeleteStudent={props.onDeleteStudent}
          isDisenrolled={isDisenrolled}
          anyLoading={anyLoading}
          user={props.user}
          isCheckin={props.student.checkin && props.student.checkin.is_virtual_center}
          isVirtualCenter={ props.student.checkin.is_virtual_center}
          teacher={isTeacher(props.user.role)
            || (props.student.checkin && props.student.checkin.is_virtual_center)}
        />
      ),
      [TABS_STUDENT_PROFILE.contract]: () => (
        <Contracts
          student={props.student}
          centerProducts={props.centerProducts}
          isDisenrolled={isDisenrolled}
          anyLoading={anyLoading}
          teacher={isTeacher(props.user.role)
            || (props.student.checkin && props.student.checkin.is_virtual_center)}
        />
      ),
      [TABS_STUDENT_PROFILE.cards]: () => (
        <CardsView student={props.student} isDisenrolled={isDisenrolled} anyLoading={anyLoading} />
      ),
      [TABS_STUDENT_PROFILE.history]: () => (
        <History
          history={props.student.historical_records}
          studentId={props.student.id}
          isDisenrolled={isDisenrolled}
          anyLoading={anyLoading}
        />
      ),
      [TABS_STUDENT_PROFILE.balance]: () => (
        <Balance
          anyLoading={anyLoading}
          student={props.student}
        />
      ),
    }
    views.Classroom.tabs = [
      { title: TABS_STUDENT_PROFILE.recent_activity },
      { title: TABS_STUDENT_PROFILE.profile },
      { title: TABS_STUDENT_PROFILE.evaluation}
    ]
    views.Classroom.views = [
      <RecentActivity
        key={shortid}
        history={props.student.latest_activities}
        onNewActivityClick={props.onNewActivityClick}
        onDeleteActivity={props.onDeleteActivity}
        isDisenrolled={isDisenrolled}
        categories={props.categories}
        student={props.student}
        onCheckIn={props.onCheckIn}
        onHealthCheck={props.onHealthCheck}
        anyLoading={anyLoading}
      />,
      <Profile
        key={shortid}
        profile={props.student}
        isDisenrolled={isDisenrolled}
        studyPrograms={props.studyPrograms}
        anyLoading={anyLoading}
        user={props.user}
        isCheckin={props.student.checkin && props.student.checkin.is_virtual_center}
        isVirtualCenter={ props.student.checkin.is_virtual_center}
        teacher={isTeacher(props.user.role)
          || (props.student.checkin && props.student.checkin.is_virtual_center)}
      />,
      <Evaluation
        key={shortid}
        student={props.student}
        isDisenrolled={isDisenrolled}
        anyLoading={anyLoading}
      />
    ]
    // Agregar tabs condicionales al mapeo (solo si no existen ya)
    if(user.user_type === 'Back Office' && tabs.some(tab => tab.title === TABS_STUDENT_PROFILE.receipts)){
      tabToComponentMap[TABS_STUDENT_PROFILE.receipts] = () => <Receipts student={student} />
      // views['Vista General'].tabs.push({title: TABS_STUDENT_PROFILE.receipts })
    }
    if (study_program) {
      if (study_program.order >= 5 && user.user_type !== 'Back Office' && tabs.some(tab => tab.title === TABS_STUDENT_PROFILE.notification)) {
        tabToComponentMap[TABS_STUDENT_PROFILE.notification] = () => <Notifications disabledNotifications={student.disabled_notifications} />
        // views['Vista General'].tabs.push({ title: TABS_STUDENT_PROFILE.notification })
      }
    }
    if(!userHasRole(user, ['Teacher', 'Nurse','Receptionist']) && tabs.some(tab => tab.title === TABS_STUDENT_PROFILE.evaluation)){
      tabToComponentMap[TABS_STUDENT_PROFILE.evaluation] = () => (
        <Evaluation
          student={props.student}
          isDisenrolled={isDisenrolled}
          anyLoading={anyLoading}
        />
      )
      // views['Vista General'].tabs.push({ title: TABS_STUDENT_PROFILE.evaluation })
    }
    if (student.country_id === 1 /*&& is_impersonating || user_type === 'Back Office'*/ && student.country_id !== 2 && !userHasRole(user, ['Teacher', 'Nurse','Receptionist']) && tabs.some(tab => tab.title === TABS_STUDENT_PROFILE.invoices)) {
      tabToComponentMap[TABS_STUDENT_PROFILE.invoices] = () => <Invoices studentId={id} />
      // views['Vista General'].tabs.push({ title: TABS_STUDENT_PROFILE.invoices })
    }

    // Documents tab - available for Director and Coordinator roles
    if (tabs.some(tab => tab.title === TABS_STUDENT_PROFILE.documents)) {
      tabToComponentMap[TABS_STUDENT_PROFILE.documents] = () => <StudentDocumentRepository studentId={id} />
    }
    
    // Generar views dinámicamente basándose en todas las tabs disponibles (incluyendo las condicionales)
    // Filtrar tabs que no tienen componente asociado
    views['Vista General'].tabs = views['Vista General'].tabs.filter(tab => {
      const tabTitle = tab.title || tab
      return tabToComponentMap[tabTitle] !== undefined
    })
    
    views['Vista General'].views = views['Vista General'].tabs
      .map(tab => {
        const tabTitle = tab.title || tab
        const componentFactory = tabToComponentMap[tabTitle]
        return componentFactory ? componentFactory() : null
      })
      .filter(view => view !== null)
  }
  return views
}

// const addViewReceipt = (user_type,tabs,views,student) => {
//    user_type === 'Back Office' ?  tabs.push({title: 'Recibos' }) : null
//    user_type === 'Back Office' ? views.push( <Receipts student={student}/>):null
// }
const checkUserType = (user) => {
    let vista
    if(user === 'Center Operation'|| user === 'Back Office' ){  vista='Vista General'} else if (user === 'Classroom'){ vista=user}
    return vista;
  }

class ProfilePageContent extends Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }
  render() {
    const { student, user, activeAccount } = this.props
    return (
      <Container>
        <DesktopContainer>
          <PageContainer>
            {path(['student', 'latest_activities'], this.props) && path(['student', 'checkin'], this.props) ?
              <Tabs
                tabs={Views(this.props, student.checkin.is_virtual_center)[checkUserType(user.user_type)].tabs}
                content={
                  Views(this.props, student.checkin.is_virtual_center)[checkUserType(user.user_type)].views
                }
                borderBottom
                activeTab={activeAccount ? 'Estado de cuenta' : null}
              />
              :
              <PageContainer>
                <Modal isOpened loading />
              </PageContainer>
            }
          </PageContainer>
        </DesktopContainer>
        <MobileContainer>
          <PageContainerMobile>
            {path(['student', 'latest_activities'], this.props) ?
              <Tabs
                tabs={
                  [
                    {
                      title: TABS_STUDENT_PROFILE.recent_activity,
                    },
                    {
                      title: TABS_STUDENT_PROFILE.profile,
                    },
                  ]}
                content={
                  [
                    <RecentActivity
                      key={shortid}
                      history={student.latest_activities}
                      onNewActivityClick={this.props.onNewActivityClick}
                      onDeleteActivity={this.props.onDeleteActivity}
                      categories={this.props.categories}
                      onCheckIn={this.props.onCheckIn}
                      student={student}
                      onHealthCheck={this.props.onHealthCheck}
                    />,
                    <ProfileMobile
                      key={shortid}
                      profile={this.props.student}
                      user={this.props.user}
                    />,
                  ]
                }
                activeTab={activeAccount ? 'Estado de cuenta' : null}
              />
              :
              <PageContainerMobile>
                <Modal isOpened loading />
              </PageContainerMobile>
            }
          </PageContainerMobile>
        </MobileContainer>
      </Container>
    )
  }
}

ProfilePageContent.propTypes = {
  student: PropTypes.object,
  loading: PropTypes.bool,//eslint-disable-line
  onDeleteActivity: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
}

ProfilePageContent.defaultProps = {
  student: undefined,
  loading: false,
}

const mapStateToProps = state => ({
  activeAccount: state.unvalidatedReceipts.toProfile,
  user: state.auth.user,
})


const mapDispatchToProps = () => ({
})

export default connect(mapStateToProps, mapDispatchToProps)(ProfilePageContent)



// WEBPACK FOOTER //
// ./src/Containers/StudentProfile/ProfilePageContent.jsx